<p-card class="p-card container">
  <h3 i18n>Exigences de questionnaires supplémentaires</h3>

  <form class="flex flex-column gap-3" [formGroup]="form">
    <div class="layout__inner-card flex flex-column gap-3">
      <h4 i18n>Question supplémentaire personnalisée</h4>
      <p i18n>Écrire une question supplémentaire personnalisée ci-dessous.</p>
      <textarea
        placeholder="Aa..."
        [formControl]="form.controls.customQuestion"
        [maxlength]="5000"
        [autoResize]="isReadonly"
        rows="4"
        class="w-full"
        pInputTextarea></textarea>

      <p-button
        (onClick)="submitCustomQuestionnaire()"
        [loading]="customQuestionnaireBtnLoading"
        [disabled]="form.controls.customQuestion.invalid || isReadonly"
        class="flex justify-content-end"
        icon="pi pi-check"
        i18n-label
        label="Exiger un questionnaire supplémentaire"></p-button>
    </div>

    <div class="layout__inner-card flex flex-column gap-3">
      <h4 i18n>Demander un ou des questionnaires supplémentaires</h4>

      <div class="flex flex-wrap row-gap-3">
        @for (extraQuestionnaire of extraQuestionnaires; track extraQuestionnaire; let i = $index) {
          <p-checkbox
            class="w-4"
            [label]="extraQuestionnaire.title"
            name="extraQuestionnaire"
            [binary]="true"
            [value]="getFormControl(extraQuestionnaire.id).value"
            [formControl]="getFormControl(extraQuestionnaire.id)"></p-checkbox>
        }
      </div>

      <p-button
        (onClick)="submitPresetQuestionnaire()"
        [loading]="presetQuestionnaireBtnLoading"
        [disabled]="form.hasError('atLeastOneCheckedInvalid') || isReadonly"
        class="flex justify-content-end"
        i18n-label
        label="Demander les questionnaires"
        icon="pi pi-check"></p-button>
    </div>
  </form>
</p-card>
